import { render, staticRenderFns } from "./ViewDepartments.vue?vue&type=template&id=25767de8&scoped=true"
import script from "./ViewDepartments.vue?vue&type=script&lang=js"
export * from "./ViewDepartments.vue?vue&type=script&lang=js"
import style0 from "./ViewDepartments.vue?vue&type=style&index=0&id=25767de8&prod&lang=css"
import style1 from "./ViewDepartments.vue?vue&type=style&index=1&id=25767de8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25767de8",
  null
  
)

export default component.exports